<template>
  <v-main class="main-container pt-4">
    <v-container fluid class="text-center" v-if="loading">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-overlay :opacity="1" color="background">
            <v-progress-circular
              indeterminate
              :width="4"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid v-if="!loading && error">
      <v-row fill-height align="center" justify="center" v-if="error">
        <v-col cols="12" sm="8" md="4">
          <v-alert outlined prominent type="error" v-if="error" :icon="false">
            <h3 class="title">
              {{ $t("views.serviceLog.error") }}
            </h3>
            {{
              $t("views.serviceLog.somethingWentWrongPleaseTryAgainInAMoment")
            }}

            <v-divider class="my-4 white" style="opacity: 0.22"></v-divider>
            <small>{{ error }}</small>
          </v-alert>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      fluid
      v-if="
        !loading && !error && (upcomingEntries.length > 0 || responsiveDealer)
      "
    >
      <v-row align="center" justify="center" class="px-2">
        <v-col cols="12" sm="8" md="4">
          <upcoming-log-entry
            class="mb-6"
            :due-entry-clustered="dueEntriesClustered"
            :upcoming-entry-clustered="upcomingEntriesClustered"
            v-if="upcomingEntries.length > 0"
            @reloadAll="fetchServiceLog($event)"
          ></upcoming-log-entry>

          <!-- <v-btn
            color="primary"
            block
            class="button"
            @click="openServiceRequest"
          >
            <span>
              {{ $t("views.serviceLog.requestService") }}
            </span>
          </v-btn> -->
          <v-bottom-sheet v-model="showingRequestAssistanceDialog">
            <template v-slot:activator="{ on }">
              <v-btn
                :color="serviceJustRequested ? 'green' : 'primary'"
                v-if="getDemoModeStatus"
                outlined
                block
                class="button"
                @click="handleOpenDemoModeDialog"
              >
                <span>
                  {{ $t("views.serviceLog.requestService") }}
                </span>
              </v-btn>
              <v-btn
                v-else
                :color="serviceJustRequested ? 'green' : 'primary'"
                outlined
                v-on="on"
                block
                class="button"
                @click="prefillDefaultRequestMessage"
              >
                <span v-if="!serviceJustRequested">
                  {{ $t("views.serviceLog.requestService") }}
                </span>
                <span v-if="serviceJustRequested">
                  <!-- <v-icon left>mdi-check</v-icon> -->
                  {{ $t("views.serviceLog.requestSent") }}
                </span>
              </v-btn>
            </template>

            <v-card
              :loading="requestAssistanceLoading"
              style="border-radius: 20px 20px 0px 0px;"
              class="px-5"
            >
              <v-form lazy-validation ref="req-assistance-form">
                <!-- <v-toolbar class="elevation-0" style="border-radius:20px"> -->
                <!-- <v-btn icon @click="showingRequestAssistanceDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn> -->
                <v-card-title class="pl-0 pb-1">
                  {{ $t("views.serviceLog.requestService") }}
                </v-card-title>
                <!-- <v-spacer></v-spacer>
                </v-toolbar> -->

                <v-container fluid class="px-0">
                  <v-row align="center" justify="center" no-gutters>
                    <v-col cols="12" sm="8" md="4">
                      <v-card-text class="pa-0 mb-3">
                        <span>
                          {{
                            $t(
                              "views.serviceLog.youAreAboutToReachOutToForAssistanceWithServicingYourBoat",
                              { responsiveDealer: responsiveDealer.name }
                            )
                          }}
                        </span>
                      </v-card-text>
                    </v-col>
                    <v-col cols="12" sm="8" md="4">
                      <v-card-text class="pa-0">
                        <v-textarea
                          class="mt-4"
                          outlined
                          auto-grow
                          name="assistanceMessage"
                          :label="$t('views.serviceLog.enterYourMessage')"
                          v-model="assistanceMessage"
                          :rules="reqAssistanceMessageRules"
                          :hint="
                            $t('views.serviceLog.messageForServicingPartner')
                          "
                          required
                        ></v-textarea>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>

              <v-row class="pb-5" no-gutters align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                  <v-btn
                    @click="requestAssistance()"
                    block
                    color="primary"
                    class="button mx-auto"
                  >
                    <!-- <v-icon left>mdi-plus</v-icon> -->
                    {{ $t("views.serviceLog.send") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-bottom-sheet>

          <p class="body-2 mt-6 text" v-if="responsiveDealer">
            {{
              $t(
                "views.serviceLog.youCanReachOutToForQuotesOrAssistanceWithServicingYourBoat",
                { responsiveDealer: responsiveDealer.name }
              )
            }}
          </p>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-if="!loading && !error" fluid class="px-0 mb-0 pb-0 pt-0">
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" sm="8" md="4">
          <v-card
            flat
            tile
            color="background"
            class="mx-auto px-2 py-0 mt-2 service-log-card d-flex flex-column"
          >
            <v-card-title class="px-3 pb-2 service-log-title pt-0">
              <span class="label"
                >{{ $t("views.serviceLog.serviceHistory") }}
              </span></v-card-title
            >
            <p class="body-2 mb-5 px-3 text" v-if="entries.length !== 0">
              {{
                $t(
                  "views.serviceLog.keepYourServiceHistoryUpdatedByEnteringCompletedMaintenanceTasks"
                )
              }}
            </p>

            <v-row no-gutters class="mx-3 mb-5" v-if="entries.length !== 0">
              <v-col cols="12">
                <v-btn
                  v-if="getDemoModeStatus"
                  @click="handleOpenDemoModeDialog()"
                  block
                  color="primary"
                  class="button"
                >
                  {{ $t("views.serviceLog.addNewRecord") }}
                </v-btn>
                <v-btn
                  v-else
                  class="button"
                  @click="openAddNewEntry()"
                  block
                  color="primary"
                >
                  {{ $t("views.serviceLog.addNewRecord") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="entries.length !== 0">
              <v-col cols="12">
                <v-card-text class="pa-3 pt-1 mb-10">
                  <div>
                    <log-entry
                      class="mb-5"
                      :entry="entry"
                      v-for="entry in entries"
                      :key="entry.uuid"
                      @update="updateEntry"
                    />
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      class="px-5 pt-0 pb-5 d-flex flex-column"
      style="height:100%; width:100%;"
      fluid
      v-if="!loading && !error && (!entries || entries.length === 0)"
    >
      <v-row
        no-gutters
        v-if="entries.length === 0"
        justify="center"
        align="center"
      >
        <v-col cols="12" sm="8" md="4" class="d-flex flex-column align-center">
          <v-card-title class="no-entries--title mx-auto">
            <span style="word-break: keep-all;">
              {{ $t("views.serviceLog.noRecords") }}
            </span>
          </v-card-title>
          <p class="body-2 no-entries--subtitle">
            {{
              $t(
                "views.serviceLog.keepYourServiceHistoryUpdatedByEnteringCompletedMaintenanceTasks"
              )
            }}
          </p>
        </v-col>
      </v-row>

      <v-row align="end" justify="center" no-gutters>
        <v-col cols="12" sm="8" md="4">
          <v-btn
            v-if="getDemoModeStatus"
            @click="handleOpenDemoModeDialog()"
            block
            color="primary"
            class="button"
          >
            {{ $t("views.serviceLog.addNewRecord") }}
          </v-btn>
          <v-btn
            v-else
            @click="openAddNewEntry()"
            block
            color="primary"
            class="button"
          >
            {{ $t("views.serviceLog.addNewRecord") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
// @ is an alias to /src
import LogEntry from "@/components/LogEntry.vue";
import UpcomingLogEntry from "@/components/UpcomingLogEntry.vue";
import { mapState, mapGetters } from "vuex";
import {
  fetchResponsiveDealer,
  loadEntries,
  fetchUpcomingServiceEvents,
  generalAssistanceRequest,
} from "@/api/log-entries";

function isEntryDueEngineHours(entry) {
  /*
  yes, no, undefined (for no engine condition.)
  */
  if (entry.should_be_engine_seconds_before) {
    let dueIn =
      (Number(entry.should_be_engine_seconds_before) - entry.engine_seconds) /
      3600;

    return dueIn <= 0;
  }
  return undefined;
}

function isEntryDueAge(entry) {
  /*
  yes, no, undefined (for no age condition.)
  */

  if (entry.should_be_done_before) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

    let date = new Date(Date.parse(entry.should_be_done_before));

    const diffDays = Math.round((date - new Date()) / oneDay);

    return diffDays <= 0;
  }
  return undefined;
}

function isEntryDue(entry) {
  return isEntryDueEngineHours(entry) || isEntryDueAge(entry);
}

function isEntryUpcoming(entry) {
  return !isEntryDue(entry);
}

function formattedEngineIntervalStatus(entry, intervals, $t) {
  if (!entry.should_be_engine_seconds_before) {
    return;
  }

  let dueIn =
    (Number(entry.should_be_engine_seconds_before) - entry.engine_seconds) /
    3600;
  let absDueIn = Math.abs(dueIn).toFixed(0);

  // let engineInterval = intervals.filter((x) => x.source === "ENGINE_HOURS")[0];

  // let atEvery = engineInterval.periodic ? 'every' : 'at';
  // let engineIntervalFormatting = `${engineInterval.value}h inspection`;

  let dueAt = Math.abs(
    Number(entry.should_be_engine_seconds_before) / 3600
  ).toFixed(0);

  if (dueIn < 0) {
    return $t("views.serviceLog.dueSinceEngineHours", {
      dueAt: dueAt,
    });
  } else {
    return $t("views.serviceLog.dueAtEngineHours", {
      dueAt: dueAt,
    });
  }
}

function formattedAgeIntervalStatus(entry, intervals, $t) {
  if (!entry.should_be_done_before) {
    return;
  }
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

  let date = new Date(Date.parse(entry.should_be_done_before));

  const diffDays = Math.round((date - new Date()) / oneDay);
  const absDiffDays = Math.abs(diffDays);

  const rtf1 = new Intl.RelativeTimeFormat("en", { style: "narrow" });

  // let ageInterval = intervals.filter((x) => x.source === "ITEM_AGE_MONTHS")[0];
  // let atEvery = ageInterval.periodic ? "every" : "at";
  // let ageIntervalFormatting = `${ageInterval.value} months inspection`;
  //  (${ageIntervalFormatting})

  if (diffDays < 0) {
    return $t("views.serviceLog.dueSinceDays", {
      days: absDiffDays,
    });
  } else {
    return $t("views.serviceLog.dueDays", {
      days: rtf1.format(diffDays, "day"),
    });
  }
}

function serviceReminderStatus(entry, intervals, $t) {
  /*
  If any condition (engine hours, age) is due, prefer it
  over the upcoming condition.

  When both condition due, or overdue, prefer age display.
  */

  let isEngineDue = isEntryDueEngineHours(entry);
  let isAgeDue = isEntryDueAge(entry);

  // Handle due
  if (isEngineDue) {
    return formattedEngineIntervalStatus(entry, intervals, $t);
  } else if (isAgeDue) {
    return formattedAgeIntervalStatus(entry, intervals, $t);
  }

  // Don't get cought into undefined!
  if (isEngineDue === false) {
    return formattedEngineIntervalStatus(entry, intervals, $t);
  } else if (isAgeDue === false) {
    return formattedAgeIntervalStatus(entry, intervals, $t);
  }

  console.error("Undefined due condition");

  return this.$t("views.serviceLog.due");
}

function generateEntryClusters(entries, $t) {
  /* There can be multiple entries for each item. Clustering groups them per-item (not item instance!), and sorts them approximately in ascending order (more due earlier).  */

  let itemClusters = entries.reduce((acc, entry) => {
    if (!acc[entry.crm_boat_item.crm_item.uuid])
      acc[entry.crm_boat_item.crm_item.uuid] = []; //If this type wasn't previously stored

    acc[entry.crm_boat_item.crm_item.uuid].push(entry);
    return acc;
  }, {});

  let clusterArray = Object.keys(itemClusters)
    .map((key) => {
      return itemClusters[key].reduce((acc_cluster, entry) => {
        // implement clusters
        let title = entry.crm_service.short_task;
        let uuid = entry.uuid;

        let itemName =
          entry.crm_boat_item && entry.crm_boat_item.crm_item
            ? entry.crm_boat_item.crm_item.formatted_name
            : null;
        let boatItemUUIDs = entry.crm_boat_item
          ? entry.crm_boat_item.uuid
          : Math.random().toString();

        let itemUUID = entry.crm_boat_item.crm_item.uuid;

        let engine_seconds = entry.engine_seconds;
        let should_be_done_before = entry.should_be_done_before
          ? new Date(entry.should_be_done_before)
          : entry.should_be_done_before;
        let should_be_engine_seconds_before =
          entry.should_be_engine_seconds_before;
        let intervals = entry.crm_service.intervals;
        let dueAt = serviceReminderStatus(entry, intervals, $t);
        let subtasks = entry.crm_service.subtasks;
        // FIXME: this is wrong!!!
        let itemInstancesCount = [
          ...new Set(itemClusters[key].map((x) => x.crm_boat_item.uuid)),
        ].length;

        if (Object.keys(acc_cluster).length === 0) {
          acc_cluster = {
            itemName,
            boatItemUUIDs, //part uuid (as key)
            itemUUID,
            should_be_engine_seconds_before: null,
            should_be_done_before: null,
            engine_seconds,
            services: [],
            itemInstancesCount,
          };
        }

        // Serivces contains all the services for all instances of the item.
        // In the rendering, we don't want to display duplicates!
        // But when the user marks something as done, it marks them all as done!

        acc_cluster.services.push({
          title,
          uuid,
          subtasks,
          should_be_engine_seconds_before,
          should_be_done_before,
          dueAt,
        });

        return acc_cluster;
      }, {});
    })
    .map((cluster) => {
      // cluster["servicesTitle"] = cluster.services
      //   .map((service) => service.title)
      //   .join(", ");

      // TODO: add counts

      cluster["should_be_engine_seconds_before"] = cluster.services.reduce(
        (best, service) => {
          if (best == null) {
            return service.should_be_engine_seconds_before;
          }

          if (service.should_be_engine_seconds_before && best) {
            if (service.should_be_engine_seconds_before < best) {
              return service.should_be_engine_seconds_before;
            }
          }

          return best;
        },
        null
      );

      cluster["should_be_done_before"] = cluster.services.reduce(
        (best, service) => {
          if (best == null) {
            return service.should_be_done_before;
          }

          if (service.should_be_done_before && best) {
            if (service.should_be_done_before < best) {
              return service.should_be_done_before;
            }
          }

          return best;
        },
        null
      );

      //TODO: select best dueAt, not first
      cluster["dueAt"] = cluster.services[0].dueAt;

      // mark duplicate services as invisible, so as not to clutter the interface.
      // NOTE: this assumes all items have the same services required simultaneously. If it isn't so, this result is misleading

      function isServiceDuplicate(service, services) {
        return services.some((otherService) => {
          if (service.uuid == otherService.uuid) {
            return false;
          }

          // naive duplication criteria
          return (
            otherService.hidden == false &&
            service.dueAt === otherService.dueAt &&
            service.title === otherService.title &&
            service.subtasks.length == otherService.subtasks.length
          );
        });
      }

      cluster.services.forEach((service, index) => {
        service.hidden = isServiceDuplicate(service, cluster.services);
      });

      cluster.dedupedServices = cluster.services.filter(
        (service) => !service.hidden
      );

      return cluster;
    });

  return clusterArray;
}

// function formatEntries(entries, overrides) {
//   overrides = overrides || {};

//   let content = entries.map((entry) => {
//     let title = entry.crm_service.short_task;
//     let uuid = entry.uuid;
//     let itemName =
//       entry.crm_boat_item && entry.crm_boat_item.crm_item
//         ? entry.crm_boat_item.crm_item.name
//         : null;

//     let engine_seconds = entry.engine_seconds;
//     let should_be_done_before = entry.should_be_done_before;
//     let should_be_engine_seconds_before = entry.should_be_engine_seconds_before;
//     let dueAt = serviceReminderStatus(entry);
//     let subtasks = entry.crm_service.subtasks;

//     // TODO: append Due info
//     return {
//       title,
//       uuid,
//       itemName,
//       should_be_engine_seconds_before,
//       should_be_done_before,
//       engine_seconds,
//       dueAt,
//       subtasks,
//     };
//   });

//   let author = null;
//   let created = null;
//   let attachments = [];
//   let title = "";
//   let responsive_dealer = { name: "" };
//   let status = overrides.status || "due";
//   let contentType = "SERVICE_LIST";
//   let notes = [{ content, contentType }];

//   return content;
// }

export default {
  name: "ServiceLog",
  components: {
    LogEntry,
    UpcomingLogEntry,
  },
  data: () => ({
    error: null,
    loading: true,
    entries: [],
    upcomingEntries: [],
    responsiveDealer: null,
    serviceJustRequested: false,
    assistanceMessage: "",
    reqAssistanceMessageRules: [],
    requestAssistanceLoading: false,
    showingRequestAssistanceDialog: false,
  }),
  created() {
    if (this.userBoatId !== null && this.accessToken !== null) {
      this.fetchServiceLog(false);
    }
  },
  watch: {
    // call again the method if the route changes
    accessToken() {
      if (this.userBoatId !== null && this.accessToken !== null) {
        this.fetchServiceLog(false);
      }
    },
  },
  computed: {
    ...mapState({
      accessToken: (s) => s.accessToken,
      userBoatId: (s) => s.userBoatId,
    }),
    ...mapGetters(["getTheme", "getUserBoat", "getDemoModeStatus"]),
    filteredUpcomingEntries: function() {
      function addMonths(date, months) {
        date.setMonth(date.getMonth() + months);
        return date;
      }

      return this.upcomingEntries.filter(isEntryUpcoming).filter((x) => {
        if (x.should_be_done_before) {
          return (
            new Date(Date.parse(x.should_be_done_before)) >
            addMonths(new Date(), -6)
          );
        } else {
          return x;
        }
      });
    },
    filteredDueEntries: function() {
      return this.upcomingEntries.filter(isEntryDue);
    },
    // dueOrUpcomingEntriesAvailable: function() {
    //   return this.upcomingEntries.length > 0
    // },
    // dueOrUpcomingEntriesNote: function () {
    //   if (this.upcomingEntries.length === 0) {
    //     return null;
    //   }

    //   let status = "due";
    //   if (this.filteredDueEntries.length > 0) {
    //     status = "overdue";
    //   }

    //   return formatEntries(this.upcomingEntries);
    // },
    // dueEntriesNote: function () {
    //   if (this.filteredDueEntries.length === 0) {
    //     return [];
    //   }

    //   return formatEntries(this.filteredDueEntries);
    // },
    // upcomingEntriesNote: function () {
    //   if (this.filteredUpcomingEntries.length === 0) {
    //     return [];
    //   }

    //   return formatEntries(this.filteredUpcomingEntries);
    // },
    dueEntriesClustered: function() {
      if (this.filteredDueEntries.length === 0) {
        return [];
      }

      return generateEntryClusters(this.filteredDueEntries, this.$t.bind(this));
    },
    upcomingEntriesClustered: function() {
      if (this.filteredUpcomingEntries.length === 0) {
        return [];
      }

      return generateEntryClusters(
        this.filteredUpcomingEntries,
        this.$t.bind(this)
      );
    },

    suggestedRequestServiceMessage: function() {
      let dueTitles = this.dueEntriesClustered.map((x) => x.itemName);
      let upcomingTitles = this.upcomingEntriesClustered.map((x) => x.itemName);

      let deduped = [...new Set(dueTitles.concat(upcomingTitles))];

      if (deduped.length === 0) {
        return "";
      }

      let message = deduped.join("\n");
      message = this.$t(
        "views.serviceLog.itSeemsIHaveSomeServiceTasksDueForMessageCanYouSendMeAnOfferAndSuggestAScheduleForMaintenance",
        { message: message }
      );

      return message;
    },
  },
  methods: {
    openServiceRequest() {
      this.$router.push({
        name: "requestService",
        params: { message: this.suggestedRequestServiceMessage },
      });
    },
    setInitailData() {
      this.reqAssistanceMessageRules = [
        (v) => !!v || this.$t("views.serviceLog.messageIsRequired"),
        (v) =>
          (v && v.length > 10) || this.$t("views.serviceLog.messageIsTooShort"),
      ];
    },
    prefillDefaultRequestMessage() {
      this.assistanceMessage = this.suggestedRequestServiceMessage;
      this.showingRequestAssistanceDialog = true;
    },
    handleOpenDemoModeDialog() {
      this.$store.commit("setDemoModeDialogStatus", true);
    },
    requestAssistance() {
      let valid = this.$refs["req-assistance-form"].validate();

      if (!valid) {
        return;
      }
      // TODO: only load on the dialog, not here
      this.requestAssistanceLoading = true;

      generalAssistanceRequest(
        this.accessToken,
        this.userBoatId,
        this.assistanceMessage
      )
        .then(() => {
          this.requestAssistanceLoading = false;
          this.showingRequestAssistanceDialog = false;
          this.serviceJustRequested = true;

          setTimeout(() => {
            this.serviceJustRequested = false;
          }, 8000);

          this.assistanceMessage = "";
        })
        .catch((error) => {
          this.requestAssistanceLoading = false;
          console.error(error);
        });
    },
    updateEntry(entryId, newEntry) {
      const index = this.entries.findIndex((x) => x.uuid === entryId);
      this.entries.splice(index, 1, newEntry);
    },
    openAddNewEntry: function() {
      this.$router.push("new");
    },
    fetchServiceLog: function(force = false) {
      this.upcomingEntries = [];
      this.error = this.entries = null;
      this.loading = true;
      this.responsiveDealer = null;
      let that = this;
      if (this.accessToken === null) {
        console.error("Trying to fetch suggestions without an access token");
        return;
      }

      let dealerPromise;
      if (this.userBoat == null || force) {
        dealerPromise = this.$store
          .dispatch("fetchUserBoat")
          .then((response) => {
            that.responsiveDealer = response.current_partner;
          });
      } else {
        //NOTE: Use of promises is only intended to be consistent
        dealerPromise = new Promise((resolve, reject) => {
          resolve(this.getUserBoat);
        }).then((response) => {
          that.responsiveDealer = response.current_partner;
        });
      }

      let entriesPromise = loadEntries(this.accessToken, this.userBoatId).then(
        function(response) {
          that.entries = response.results.filter((x) => {
            return x.status === "DONE";
          });
        }
      );

      let upcomingPromise = fetchUpcomingServiceEvents(
        that.accessToken,
        that.userBoatId
      ).then(function(response) {
        that.upcomingEntries = response.results;
      });

      Promise.all([dealerPromise, entriesPromise, upcomingPromise])
        .then(() => {
          that.loading = false;
        })
        .catch((error) => {
          that.error = error;
          that.loading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
.service-log-title {
  display: block;
  overflow: hidden;
  > img {
    background-color: white;
    border: 15px;
    padding: 10px;
    border-radius: 50%;
    // display: block;
    // float: left;
  }
  .label {
  }
}

.main-container {
  min-height: 100%;
  height: 100%;

  > .v-main__wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .service-log-container {
    //  flex-grow: 1;
  }
}

.text {
  color: #646464;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.service-log-card {
  min-height: 100%;
}
.button--bottom {
  text-transform: unset !important;
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  border-radius: 10px;
  height: 48px !important;
  position: sticky;
  width: 100%;
  bottom: 40px;
}

.button {
  text-transform: unset !important;
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  border-radius: 10px;
  height: 48px !important;
}

.no-entries--title {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #1e1e1e;
}

.no-entries--subtitle {
  color: #646464;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
</style>
